export class SousService {
  id: number;
  name: string;
  website: string;
  category: string;
  image_url: string;
  description: string;
  prix: string;
  listimages: string[]; // Fixed syntax: type goes after the colon
}